<template>
  <header class="edit-header flex-align">
    <h3 class="edit-header__title font-labelheavy">{{ title }}</h3>

    <!-- action -->
    <slot name="action" v-if="visibleAction && limitShow">
      <el-button
        v-show="!modelValue"
        type="text"
        icon=" iconfont icon-bianji"
        @click="handleActionClick"
        class="edit-header__btn edit-header__btn--edit flex-align font-labelheavy"
      >
        编辑
      </el-button>
      <div class="edit-header__btns" v-show="modelValue">
        <el-button
          plain
          type="primary"
          @click="handleSaveClick"
          class="edit-header__btn edit-header__btn--save"
        >
          保存
        </el-button>
        <el-button
          type="text"
          @click="handleCancelClick"
          class="edit-header__btn edit-header__btn--cancel"
        >
          取消
        </el-button>
      </div>
    </slot>
    <!-- <slot name="action" v-if="visibleAction && !limitShow"> </slot> -->
    <slot name="action" v-if="visibleAdd && addLimit">
      <div
        class="font-labelheavy edit-header__add"
        @click="$emit('onAddClick')"
      >
        <img
          class="edit-header__add-img"
          src="../../assets/images/normal_add.svg"
          alt=""
        />
        <span class="edit-header__add-text">{{ addText }}</span>
      </div>
    </slot>
  </header>
</template>

<script>
import { mapMutations, mapGetters } from 'vuex';
import { modelMixin } from '../../assets/js/mixins/model';
import { roleJudge } from '../../config/roleJudge';

export default {
  name: 'EditHeader',

  mixins: [modelMixin],

  props: {
    title: {
      type: String,
      default: ''
    },
    visibleAction: {
      type: Boolean,
      default: true
    },
    visibleAdd: {
      type: Boolean,
      default: false
    },
    addText: {
      type: String,
      default: ''
    },
    addLimit: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
      relicAddFor: false
    };
  },
  computed: {
    ...mapGetters('login', ['limitShow'])
  },
  created() {},
  methods: {
    /**
     * * 操作按钮点击回调
     */
    handleActionClick() {
      this.modelValue = !this.modelValue;
      this.$emit('onEditClick');
      this.$emit('onActionClick');
    },

    /**
     * * 保存按钮点击回调
     */
    handleSaveClick() {
      this.modelValue = !this.modelValue;
      this.$emit('onSaveClick');
    },

    /**
     * * 保存按钮点击回调
     */
    handleCancelClick() {
      this.modelValue = !this.modelValue;
      this.$emit('onCancelClick');
    }
  }
};
</script>

<style lang="scss">
.edit-header {
  justify-content: space-between;
  padding-bottom: 6px;
  border-bottom: 1px solid $color-border-light;
  &__add {
    cursor: pointer;
    // padding-bottom: 6px;
    &-img {
      width: 20px;
      height: 20px;
      margin-right: 5px;
    }
    &-text {
      color: $color-primary;
    }
  }
  &__title {
    color: #555;
    font-weight: 900;
  }
  &__btns {
    // padding-bottom: 6px;
  }
  &__btn {
    &--edit {
      height: 30px;
      border: 0;
      text-decoration: none;
    }
    &--save {
      height: 24px;
    }
    &--cancel {
      color: $color-info;
    }
    .iconfont {
      font-size: 30px;
      transform: translateY(-2px);
    }
  }
}
</style>
